import { Check, Minus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { localizedProps } from "src/utils/localize";

// ЧТО ВКЛЮЧЕНО И ЧТО НЕ ВКЛЮЧЕНО.
//
// Читаются в паре, поэтому стоят рядом в одной сетке. Различаются знаком и
// цветом, но НЕ красным «нельзя»: «не включено» — это не ошибка и не запрет,
// а просто вторая половина честного прайса. Галочка «включено» — нефритовая
// (единственный холодный цвет палитры), «не включено» — серый минус.
const List = ({ items, title, icon: Icon, iconClass, lang }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="rounded-xl border border-kj-line bg-kj-card/50 p-4 sm:p-5">
      <h3 className="text-xs font-bold uppercase tracking-[0.12em] text-kj-sub">
        {title}
      </h3>
      <ul className="mt-3 flex flex-col gap-2">
        {items.map((item, i) => {
          const entry = localizedProps(item, lang);
          return (
            <li key={i} className="flex items-start gap-2.5">
              <Icon
                aria-hidden="true"
                className={`mt-[3px] h-3.5 w-3.5 flex-shrink-0 ${iconClass}`}
              />
              <span {...entry.attrs} className="text-sm text-kj-sub leading-snug">
                {entry.value}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default function IncludedLists({ included, notIncluded, className = "" }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  if ((!included || included.length === 0) && (!notIncluded || notIncluded.length === 0)) {
    return null;
  }

  return (
    <section className={`grid gap-4 sm:grid-cols-2 ${className}`}>
      <List
        items={included}
        title={t("tour.includedTitle")}
        icon={Check}
        // Зелёная галочка, а не золотая: «включено» должно считываться
        // мгновенно, знаком, а не цветом бренда. Тон приглушённый —
        // светофорная зелень на сливовом фоне выглядит как ошибка валидации.
        iconClass="text-kj-ok"
        lang={lang}
      />
      <List
        items={notIncluded}
        title={t("tour.notIncludedTitle")}
        icon={Minus}
        iconClass="text-kj-sub"
        lang={lang}
      />
    </section>
  );
}
